import React, { useEffect, useState } from "react";
import { useLoading, useUser } from "@/contexts";
import { indicationsService, IndicationRecord } from "@/services";
import { ShareModal } from "@/components";
import { formatPercentage, formatPrice } from "@/utils";
import "./Indications.css";

const IndicationsScreen: React.FC = () => {
  const { userData: currentUser } = useUser();
  const { withLoading } = useLoading();

  const COMMISSION_VALUE = Number(process.env.REACT_APP_COMMISSION_VALUE ?? 0);

  const [indications, setIndications] = useState<IndicationRecord[]>([]);
  const [totalCommission, setTotalCommission] = useState(0);

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const fetchData = async () => {
    if (!currentUser?.uid) return;

    await withLoading(async () => {
      if (currentUser?.usernameSlug) {
        const history = await indicationsService.getMyIndications(
          currentUser.usernameSlug,
        );

        if (history) {
          setIndications(history);
          setTotalCommission(0);
        }
      }
    });
  };

  const handleShareClick = () => {
    setIsShareModalOpen(true);
  };

  const getStatusInfo = (status: string) => {
    switch (status) {
      case "completed":
        return { label: "Comissão Ganha", class: "status-succeeded" };
      case "pending":
        return { label: "Pendente", class: "status-pending" };
      default:
        return { label: "Cancelado", class: "status-failed" };
    }
  };

  useEffect(() => {
    fetchData().then();
  }, [currentUser]);

  return (
    <div className="indications-page container">
      <header className="page-header">
        <h1 className="auth-title">Minhas Indicações</h1>
        <p className="auth-subtitle">
          Ganhe {formatPercentage(COMMISSION_VALUE)} de comissão por cada amigo
          que assinar
        </p>
      </header>

      <div className="approval-card total-commission-card">
        <div className="indication-main-info">
          <div className="payment-details">
            <span className="payment-date">Saldo Total Acumulado</span>
            <strong className="total-amount-value">
              {formatPrice(totalCommission)}
            </strong>
          </div>
          <div className="approval-icon">💰</div>
        </div>
        <p className="commission-disclaimer">
          As comissões são liberadas automaticamente após a confirmação do
          pagamento do indicado.
        </p>
      </div>

      {indications.length > 0 && (
        <>
          {indications.map((item) => {
            const status = getStatusInfo(item.status);

            return (
              <div
                key={item.id}
                className="approval-card total-commission-card"
              >
                <div className="payment-main-info">
                  <div className="payment-details">
                    <span className="payment-date">Indicado</span>
                    <strong className="payment-plan-name">
                      {item.referredUsername}
                    </strong>
                  </div>

                  <div className="payment-value-area">
                    {item.status === "completed" && (
                      <span className="payment-amount">{formatPrice(0)}</span>
                    )}

                    {item.status !== "completed" && (
                      <span className={`status-badge ${status.class}`}>
                        {status.label}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}

      {indications.length === 0 && (
        <div className="indication-card">
          <div className="approval-icon">👥</div>
          <p>
            Você ainda não indicou ninguém. <br />
            Compartilhe seu link e comece a ganhar!
          </p>
          <button className="btn-primary" onClick={handleShareClick}>
            Compartilhar
          </button>

          <ShareModal
            isOpen={isShareModalOpen}
            onClose={() => setIsShareModalOpen(false)}
            uid={currentUser?.uid || ""}
            usernameSlug={currentUser?.usernameSlug || ""}
          />
        </div>
      )}
    </div>
  );
};

export default IndicationsScreen;
